import React from 'react'
import PropTypes from 'prop-types'
import { Drawer, Row, Col, Card, Typography, Spin, Icon, Empty, Input, Button, Affix, message } from 'antd'
import { get } from 'lodash'
import { RequestV2 as Request } from 'App/Utils'
import PageNotFound from 'App/Component/PageNotFound'

// Class ini dibuat memang bukan untuk penggunaan umum,
class DrawerUsers extends React.PureComponent {
  constructor(props) {
    super(props)

    this.params = {}
    this.state = {
      isLoading: true,
      isLoadMore: false,
      isSaving: false,
      filteredUsers: [],
      next: null,
      selectedUsers: [],
    }
  }

  setThisState = (obj, callback = () => null, force) => {
    if (force) {
      return this.setState(obj, callback)
    } else {
      for (const key in obj) {
        if (obj[key] !== this.state[key]) {
          return this.setState(obj, callback)
        }
      }
    }
    return callback()
  }

  readUsers = (keyLoading = 'isLoading') => {
    this.setThisState({ [keyLoading]: true }, () => {
      Request(
        'get',
        'module-groupUser-user-read',
        {},
        { ...this.params },
        [],
        this.readUsersSuccess,
        this.readUsersFailed,
        { keyLoading }
      )
    })
  }

  readUsersSuccess = (response, extra) => {
    let mergedUsers = response.data.results
    if (extra.keyLoading === 'isLoadMore') {
      mergedUsers = [...this.state.filteredUsers, ...response.data.results]
    }
    const filteredUsers = this.filterUsers(mergedUsers)
    this.setState({ [extra.keyLoading]: false, filteredUsers, next: response.data.next })
  }

  readUsersFailed = (error, extra) => {
    message.error('Failed when retrieve users data')
    this.setState({ [extra.keyLoading]: false })
  }

  // return filtered except by members and selected users
  filterUsers = (users) => {
    const filteredUsersByMembers = users.filter(user => !this.props.members.find(member => member.pk === user.pk))
    const filteredUsers = filteredUsersByMembers.filter(user => !this.state.selectedUsers.find(selected => selected.pk === user.pk))
    return filteredUsers
  }

  onSearch = (val, event) => {
    this.params.search = val
    this.params.page = 1
    this.readUsers()
  }

  onSelectUser = (newSelectedUser) => {
    // Jangan langsung mengganti variable state, seperti push, unshift, dll.
    const { filteredUsers, selectedUsers } = this.state
    const remainingUsers = filteredUsers.filter((val) => val.pk !== get(newSelectedUser, 'pk'))
    // selectedUsers.unshift(...filteredUsers.splice(0, 1)) // don't do this
    this.setState({ filteredUsers: remainingUsers, selectedUsers: [newSelectedUser, ...selectedUsers] })
  }

  onDeselectUser = (removedUser) => {
    // Jangan langsung mengganti variable state, seperti push, unshift, dll.
    const { filteredUsers, selectedUsers } = this.state
    const remainingSelected = selectedUsers.filter((val) => val.pk !== get(removedUser, 'pk'))
    // filteredUsers.unshift(...selectedUsers.splice(0, 1)) // don't do this
    this.setState({ filteredUsers: [removedUser, ...filteredUsers], selectedUsers: remainingSelected })
  }

  onApply = () => {
    const { selectedUsers } = this.state
    if (selectedUsers.length > 0) {
      this.setState({ isSaving: true }, () => {
        setTimeout(() => {
          const ids = this.state.selectedUsers.map(val => val.pk)
          this.props.onJoinUsers(ids, this.state.selectedUsers, (isSuccess) => {
            if (isSuccess) {
              this.setState({ isSaving: false, selectedUsers: [] })
            } else {
              this.setState({ isSaving: false })
            }
          })
        }, 250)
      })
    } else {
      message.info('Please select at least 1 user to join with Group')
    }
  }

  onLoadMore = () => {
    const queryString = this.state.next.split('?')[1]
    const params = queryString.split('&')
    for (const key in params) {
      const tempParam = params[key].split('=')
      if (tempParam[0] === 'page') {
        this.params.page = tempParam[1]
        return this.readUsers('isLoadMore')
      }
    }
    return message.error('Cannot create request, no more data found.')
  }

  onRemoveAllSelected = () => {
    const { filteredUsers, selectedUsers } = this.state
    this.setState({ filteredUsers: [...selectedUsers, ...filteredUsers], selectedUsers: [] })
  }

  componentWillReceiveProps(nextProps) {
    const { filteredUsers } = this.state
    if (!this.props.visible && nextProps.visible && filteredUsers.length === 0) {
      this.readUsers()
    }
  }

  componentDidMount() {
    if (this.props.visible) {
      this.readUsers()
    }
  }

  render() {
    const { visible, onClose } = this.props
    const { isLoading, filteredUsers, selectedUsers, next, isLoadMore, isSaving } = this.state

    return (
      <Drawer
        closable={false}
        width='65%'
        bodyStyle={{ marginTop: 0, paddingTop: 0 }}
        visible={visible}
        onClose={onClose}
      >
        <Spin spinning={isLoading}>
          <Row>
            <Affix offsetTop={0} target={() => document.getElementsByClassName('ant-drawer-wrapper-body')[0]}>
              <div className='header-list-user' style={{ padding: '12px 0', backgroundColor: '#fff' }}>
                <div style={{ marginBotttom: '12px' }}>
                  <Row type='flex' justify='center' style={{ marginBottom: '12px' }}>
                    <Col style={{ fontSize: '24px', fontWeight: 500, lineHeight: 1.35, color: 'rgba(0, 0, 0, 0.85)', marginBottom: '12px', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
                      Add Member
                    </Col>
                  </Row>
                </div>
                <Row type='flex' justify='space-between' gutter={[12, 12]}>
                  <Col>
                    <Input.Search placeholder='Search...' onSearch={this.onSearch} />
                  </Col>
                  <Col>
                    <Button type='primary' icon='save' loading={isSaving} onClick={this.onApply}>
                      Apply
                    </Button>
                  </Col>
                </Row>
              </div>
            </Affix>
            <Row>
              <Col xs={24} sm={24} md={12}>
                <div style={{ padding: '12px', fontSize: '18px', fontWeight: 500, color: 'rgba(0, 0, 0, 0.85)', borderBottom: '1px solid #e8e8e8', borderRight: '1px solid #e8e8e8', textAlign: 'center', backgroundColor: '#f3f3f3' }}>
                  Available User: {filteredUsers.length}
                </div>
                { filteredUsers.length === 0 && selectedUsers.length === 0 && !next && (
                  <Row>
                    <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description='No user found' />
                    <Row type='flex' justify='center' style={{ marginTop: '12px' }}>
                      <Button onClick={() => this.readUsers()}>
                        Try again
                      </Button>
                    </Row>
                  </Row>
                )}
                { filteredUsers.map((user) => (
                  <div style={{ borderBottom: '1px solid #e8e8e8', borderRight: '1px solid #e8e8e8' }} key={user.pk}>
                    <div className='selection-row-item' onClick={() => this.onSelectUser(user)}>
                      <div style={{ fontSize: '16px', fontWeight: 500, color: '#030303', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis', marginBottom: '2px' }}>
                        {user.username} - {user.first_name} {user.last_name || ''}
                      </div>
                      <div style={{ overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
                        {get(user.home_branch, 'name', '')}
                      </div>
                    </div>
                  </div>
                ))}
                { next && (
                  <Row type='flex' justify='center' style={{ marginTop: '12px' }}>
                    <Button loading={isLoadMore} onClick={this.onLoadMore}>
                      Load more
                    </Button>
                  </Row>
                )}
              </Col>
              <Col xs={24} sm={24} md={12}>
                <div style={{ padding: '12px', fontSize: '18px', fontWeight: 500, color: 'rgba(0, 0, 0, 0.85)', borderBottom: '1px solid #e8e8e8', textAlign: 'center', backgroundColor: '#f3f3f3' }}>
                  Chosen User: {selectedUsers.length}
                  { selectedUsers.length > 0 && (
                    <span title='Remove all selected' onClick={this.onRemoveAllSelected} style={{ float: 'right', color: '#ff4d4f', cursor: 'pointer' }}>
                      x
                    </span>
                  )}
                </div>
                { selectedUsers.length === 0 && (
                  <Row type='flex' justify='center'>
                    <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description='No selected users' />
                  </Row>
                )}
                { selectedUsers.map((user) => (
                  <div style={{ borderBottom: '1px solid #e8e8e8' }} key={user.pk}>
                    <div className='selection-row-item' onClick={() => this.onDeselectUser(user)}>
                      <div style={{ fontSize: '16px', fontWeight: 500, color: '#030303', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis', marginBottom: '2px' }}>
                        {user.username} - {user.first_name} {user.last_name || ''}
                      </div>
                      <div style={{ overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
                        {get(user.home_branch, 'name', '')}
                      </div>
                    </div>
                  </div>
                ))}
              </Col>
            </Row>
          </Row>
        </Spin>
      </Drawer>
    )
  }
}

DrawerUsers.propTypes = {
  userReducer: PropTypes.object.isRequired,
  members: PropTypes.array,
  visible: PropTypes.bool,
  onClose: PropTypes.func,
  onJoinUsers: PropTypes.func,
}

DrawerUsers.defaultProps = {
  members: [],
  visible: false,
  onClose: () => null,
  onJoinUsers: () => null,
}

export default DrawerUsers